"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _sitecoreJssReact = require("@sitecore-jss/sitecore-jss-react");
var _headTags = _interopRequireDefault(require("../../components/headTags"));
var _Footer = _interopRequireDefault(require("../../components/Nav/Footer"));
var _Header = _interopRequireDefault(require("../../components/Nav/Header"));
var _lodash = require("lodash");
var _globalDataContext = require("../../lib/globalDataContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
  APP LAYOUT
  This is where the app's HTML structure and root placeholders should be defined.

  All routes share this root layout by default (this could be customized in RouteHandler),
  but components added to inner placeholders are route-specific.
*/

var DefaultFinproLayout = props => {
  var route = props.route;
  (0, _globalDataContext.setGlobalData)(props);
  var FullWidthLayoutBody = () => {
    // Used for search page  
    var pageProps = {
      displayTitle: route.fields.DisplayTitle.value,
      displayTagline: route.fields.DisplayTagline.value,
      disclaimer: route.fields.Disclaimer.value,
      showBreadCrumb: route.fields.ShowBreadcrumb.value,
      utagSiteName: props.headTagsProps.utagSiteName,
      addUtagLoginCookie: props.headTagsProps.addUtagLoginCookie
    };
    var leadFormContent = (0, _lodash.get)(route, 'placeholders.form-content');
    var formRenderingFields = leadFormContent && leadFormContent.length > 0 ? leadFormContent[0] : null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "finpro-fullwidth-layout"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-spacing--minor"
    }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
      name: "main-content-full-body",
      rendering: route,
      params: props.componentProps,
      formParams: formRenderingFields,
      pageprops: pageProps
    })), /*#__PURE__*/_react.default.createElement(_Footer.default, {
      fields: route.fields,
      componentParams: props.componentProps,
      params: props.headTagsProps
    }));
  };
  var DefaultLayoutBody = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-spacing--minor"
    }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
      name: "main-content-full-body",
      rendering: route,
      params: props.componentProps
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "container mm-spacing"
    }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
      name: "main-content",
      rendering: route,
      params: props.componentProps
    })), /*#__PURE__*/_react.default.createElement(_Footer.default, {
      fields: route.fields,
      componentParams: props.componentProps,
      params: props.headTagsProps
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_headTags.default, props.headTagsProps), /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.VisitorIdentification, null), /*#__PURE__*/_react.default.createElement(_Header.default, {
    route: route,
    params: props.componentProps,
    headTagsProps: props.headTagsProps
  }), route.fields.IsFullWidthLayout.value && /*#__PURE__*/_react.default.createElement(FullWidthLayoutBody, null), !route.fields.IsFullWidthLayout.value && /*#__PURE__*/_react.default.createElement(DefaultLayoutBody, null));
};
var _default = exports.default = DefaultFinproLayout;